import { render, staticRenderFns } from "./comment-creer-une-strategie-facebook-ads-performante.vue?vue&type=template&id=ef51a646&"
import script from "./comment-creer-une-strategie-facebook-ads-performante.vue?vue&type=script&lang=js&"
export * from "./comment-creer-une-strategie-facebook-ads-performante.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports